import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import IconBase from '../IconBase';
var Svg24X24DownloadOutline = function Svg24X24DownloadOutline(props) {
  return /*#__PURE__*/React.createElement(IconBase, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.998 13.176 3.245-3.245a1 1 0 0 1 1.414 1.414L12 17.002l-5.657-5.657a1 1 0 1 1 1.414-1.414l3.241 3.24V3.976c0-.51.448-.925 1-.925s1 .414 1 .925zM6 19h12a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2",
    clipRule: "evenodd"
  })));
};
export default Svg24X24DownloadOutline;